import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FormMode } from '../../common/form-mode';
import { WorkflowDataInterface } from '../workflow-data.interface';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Subject } from 'rxjs';
import { SendSmsActionData } from 'src/app/components/designer/models/send-sms-action-data';
import { SmsTemplate } from 'src/app/models/sms-template';
import { SmsTemplatesService } from 'src/app/services/sms-templates.service';
import { ContextualMenuEvent } from '../contextual-menu-event';
import { NeedSmsTemplates } from '../need-sms-templates';

@Component({
    selector: 'app-workflow-action-send-mail-data',
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule, FaIconComponent, MatTooltipModule, MatCheckboxModule],
    templateUrl: './workflow-action-send-sms-data.component.html',
    styleUrl: './workflow-action-send-sms-data.component.scss'
})
export class WorkflowActionSendSmsDataComponent implements WorkflowDataInterface, OnInit, NeedSmsTemplates {
    /**
     * Liste des icones utilisés dans le template.
     */
    public faCircleInfo = faCircleInfo;

    /**
     * Données affichées par le composant dynamique.
     */
    public _data: SendSmsActionData;

    /**
     * Spécifie les données affichées par le composant dynamique.
     */
    set data(value: SendSmsActionData | string) {
        if (typeof value === 'string') {
            this._data = JSON.parse(value);
        } else {
            this._data = value as SendSmsActionData;
        }

        this.fillForm();
    }

    /**
     * Obtient les données affichées par le composant dynamique.
     */
    get data(): SendSmsActionData {
        this.fillData();
        return this._data;
    }

    /**
     * Mode d'affichage du formulaire.
     */
    mode: FormMode;

    /**
     * Retourne une valeur indiquant si l'utilisateur a modifié des valeurs du formulaire.
     */
    public get dirty(): boolean {
        return this.dataForm && this.dataForm.dirty;
    }

    /**
     * Source du menu contextuel.
     */
    contextualMenuSource: Subject<ContextualMenuEvent> = new Subject<ContextualMenuEvent>();

    /**
     * Liste des modèles de mails.
     */
    public _smsTemplates: SmsTemplate[];

    /**
     * Spécifie la liste des modèles de mails.
     */
    set smsTemplates(value: SmsTemplate[]) {
        this._smsTemplates = value;
        this.fillForm();
    }

    /**
     * Instance du formulaire.
     */
    public dataForm: UntypedFormGroup;

    /**
     * Constructeur.
     */
    constructor(private smsTemplatesService: SmsTemplatesService) {}

    /**
     * Appellé lors de l'initialisation du contrôle.
     */
    ngOnInit(): void {
        this.dataForm = new UntypedFormGroup({
            templateId: new UntypedFormControl({ value: '' }, [Validators.required]),
            dontSendIfRecipientMissingEnabled: new UntypedFormControl(true),
        });

        this.fillForm();
    }

    /**
     * Indique si le formulaire est valide.
     */
    public isValid(): boolean {
        return true;
    }

    /**
     * Annulle les changements effectués par l'utilisateur.
     */
    public clearData() {
        this.dataForm.markAsPristine();
    }

    /**
     * Remplit le formulaire avec les données.
     */
    private fillForm() {
        if (this.dataForm) {
            if (this._data) {
                if (this._smsTemplates) {
                    this.dataForm.get('templateId').setValue(this._data.templateId);
                }

                this.dataForm.get('dontSendIfRecipientMissingEnabled').setValue(this._data.dontSendIfRecipientMissing);
            }
        }
    }

    /**
     * Met à jour les données à partir du formulaire.
     */
    private fillData() {
        let updatedData: SendSmsActionData = new SendSmsActionData();
        updatedData.templateId = this.dataForm.get('templateId').value;
        updatedData.dontSendIfRecipientMissing = this.dataForm.get('dontSendIfRecipientMissingEnabled').value;

        this._data = updatedData;
    }
}
